module.exports = __webpack_public_path__ + "static/media/cat-commu.8cef9ffa.svg";